import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceSchedule } from '@app/core/api-azure-functions/dataverse-functions';
import { SiteSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-service-schedule-history-model',
  templateUrl: './service-schedule-history-modal.component.html',
  styleUrls: ['./service-schedule-history-modal.scss'],
})
export class ServiceScheduleHistoryModalComponent {
  inactiveServiceSchedules$: Observable<ServiceSchedule[]> = this.store.select(
    SiteSelectors.getCurrentInactiveServiceSchedules
  );

  constructor(private store: Store<AppState>) {}
}
